import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = ({ type = 'default', count = 1, isProductCard = false }) => {
  const renderSkeleton = (skeletonType) => {
    switch (skeletonType) {
      case 'product-horizontal':
        return (
          <div className="skeleton-product-horizontal">
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
              <div className="skeleton-title"></div>
              <div className="skeleton-price"></div>
              <div className="skeleton-description"></div>
            </div>
          </div>
        );
      
      case 'product-listing':
        return (
          <div className="holder mt-0" style={{ width: '100%' }}>
            <div className="container mt-5">
              {/* Title skeleton */}
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <div className="skeleton-line" style={{ height: '32px', width: '280px', margin: '0 auto', borderRadius: '6px' }}></div>
              </div>

              {/* Filter Row skeleton */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', borderBottom: '1px solid #f2f2f2', paddingBottom: '15px' }}>
                <div className="skeleton-line" style={{ height: '20px', width: '120px', borderRadius: '4px' }}></div>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div className="skeleton-line" style={{ height: '34px', width: '100px', borderRadius: '4px' }}></div>
                  <div className="skeleton-line" style={{ height: '34px', width: '80px', borderRadius: '4px' }}></div>
                </div>
              </div>

              <div className="row">
                {/* Left side: Filter Sidebar skeleton */}
                <div className="col-lg-4" style={{ display: 'flex', flexDirection: 'column', gap: '24px', paddingRight: '20px' }}>
                  {/* Category Filter */}
                  <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', background: '#fff' }}>
                    <div className="skeleton-line" style={{ height: '18px', width: '45%', marginBottom: '16px', borderRadius: '4px' }}></div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      <div className="skeleton-line" style={{ height: '14px', width: '75%', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ height: '14px', width: '55%', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ height: '14px', width: '85%', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ height: '14px', width: '65%', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ height: '14px', width: '80%', borderRadius: '4px' }}></div>
                    </div>
                  </div>

                  {/* Price Filter */}
                  <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', background: '#fff' }}>
                    <div className="skeleton-line" style={{ height: '18px', width: '30%', marginBottom: '16px', borderRadius: '4px' }}></div>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
                      <div className="skeleton-line" style={{ flex: 1, height: '38px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ flex: 1, height: '38px', borderRadius: '4px' }}></div>
                    </div>
                    <div className="skeleton-button" style={{ height: '34px', width: '80px', margin: '0 auto', borderRadius: '4px' }}></div>
                  </div>
                </div>

                {/* Right side: Product Grid skeleton */}
                <div className="col-lg aside">
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '20px' }}>
                    {Array.from({ length: 6 }).map((_, idx) => (
                      <div key={idx} style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden', display: 'flex', flexDirection: 'column', background: '#fff' }}>
                        <div className="skeleton-image" style={{ width: '100%', height: '220px', borderRadius: '0' }}></div>
                        <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          <div className="skeleton-brand" style={{ height: '12px', width: '40%', marginBottom: '4px' }}></div>
                          <div className="skeleton-title" style={{ height: '16px', width: '90%', marginBottom: '4px' }}></div>
                          <div className="skeleton-price" style={{ height: '16px', width: '30%', marginTop: '4px' }}></div>
                          <div className="skeleton-button" style={{ height: '36px', width: '100%', borderRadius: '6px', marginTop: '12px' }}></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'product-vertical':
        return (
          <div className="prd-inside skeleton-product-vertical">
            <div className="prd-img-area">
              <div className="prd-img image-container skeleton-image" style={{ width: '100%', height: '100%', minHeight: '220px' }}></div>
            </div>
            <div className="prd-info" style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between', padding: '15px' }}>
              <div className="prd-info-wrap" style={{ textAlign: 'left' }}>
                <div className="skeleton-brand" style={{ height: '12px', width: '40%', marginBottom: '8px' }}></div>
                <div className="skeleton-title" style={{ height: '16px', width: '90%', marginBottom: '8px' }}></div>
                <div className="skeleton-title" style={{ height: '16px', width: '60%', marginBottom: '12px' }}></div>
              </div>
              <div className="my-2" style={{ textAlign: 'left' }}>
                <div className="skeleton-price" style={{ height: '18px', width: '30%' }}></div>
              </div>
              <div className="prd-action-left w-100" style={{ marginTop: 'auto' }}>
                <div className="skeleton-button" style={{ height: '38px', borderRadius: '4px', width: '100%' }}></div>
              </div>
            </div>
          </div>
        );
      
      case 'checkout':
        return (
          <div className="page-content skeleton-checkout" style={{ padding: '20px 0' }}>
            <div className="container">
              <div className="row">
                {/* Left Column: Checkout details input fields */}
                <div className="col-md-9 col-lg-10 col-xl-11">
                  <div style={{ marginBottom: '30px' }}>
                    <div className="skeleton-line" style={{ height: '22px', width: '90px', marginBottom: '15px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '45px', width: '100%', borderRadius: '4px' }}></div>
                  </div>
                  
                  <div style={{ marginBottom: '30px' }}>
                    <div className="skeleton-line" style={{ height: '22px', width: '100px', marginBottom: '15px', borderRadius: '4px' }}></div>
                    <div style={{ display: 'flex', border: '1px solid #f2f2f2', borderRadius: '4px', overflow: 'hidden', marginBottom: '15px' }}>
                      <div className="skeleton-line" style={{ flex: 1, height: '45px', borderRadius: '0' }}></div>
                      <div style={{ width: '1px', backgroundColor: '#f2f2f2' }}></div>
                      <div className="skeleton-line" style={{ flex: 1, height: '45px', borderRadius: '0' }}></div>
                    </div>
                    <div className="skeleton-line" style={{ height: '45px', width: '100%', marginBottom: '12px', borderRadius: '4px' }}></div>
                    <div style={{ display: 'flex', gap: '12px', marginBottom: '12px', flexWrap: 'wrap' }}>
                      <div className="skeleton-line" style={{ flex: 1, minWidth: '150px', height: '45px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ flex: 1, minWidth: '150px', height: '45px', borderRadius: '4px' }}></div>
                    </div>
                    <div className="skeleton-line" style={{ height: '45px', width: '100%', marginBottom: '12px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '45px', width: '100%', marginBottom: '12px', borderRadius: '4px' }}></div>
                    <div style={{ display: 'flex', gap: '12px', marginBottom: '12px', flexWrap: 'wrap' }}>
                      <div className="skeleton-line" style={{ flex: 1, minWidth: '100px', height: '45px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ flex: 1, minWidth: '100px', height: '45px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ flex: 1, minWidth: '100px', height: '45px', borderRadius: '4px' }}></div>
                    </div>
                    <div className="skeleton-line" style={{ height: '45px', width: '100%', borderRadius: '4px' }}></div>
                  </div>
                  
                  <div style={{ marginBottom: '30px' }}>
                    <div className="skeleton-line" style={{ height: '22px', width: '160px', marginBottom: '15px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '60px', width: '100%', marginBottom: '12px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '60px', width: '100%', borderRadius: '4px' }}></div>
                  </div>
                  
                  <div style={{ marginBottom: '30px' }}>
                    <div className="skeleton-line" style={{ height: '22px', width: '110px', marginBottom: '15px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '55px', width: '100%', marginBottom: '12px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '55px', width: '100%', marginBottom: '12px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '55px', width: '100%', borderRadius: '4px' }}></div>
                  </div>
                </div>
                
                {/* Right Column: Order summary totals */}
                <div className="col-md-9 col-lg-7 col-xl-7 mt-3 mt-lg-0" style={{ borderLeft: '1px solid #f2f2f2', paddingLeft: '30px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '25px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                      <div className="skeleton-image" style={{ width: '64px', height: '64px', borderRadius: '8px', flexShrink: 0 }}></div>
                      <div style={{ flex: 1, minWidth: '100px' }}>
                        <div className="skeleton-line" style={{ height: '14px', width: '80%', marginBottom: '6px', borderRadius: '4px' }}></div>
                        <div className="skeleton-line" style={{ height: '12px', width: '40%', borderRadius: '4px' }}></div>
                      </div>
                      <div className="skeleton-price" style={{ height: '16px', width: '50px', borderRadius: '4px' }}></div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                      <div className="skeleton-image" style={{ width: '64px', height: '64px', borderRadius: '8px', flexShrink: 0 }}></div>
                      <div style={{ flex: 1, minWidth: '100px' }}>
                        <div className="skeleton-line" style={{ height: '14px', width: '85%', marginBottom: '6px', borderRadius: '4px' }}></div>
                        <div className="skeleton-line" style={{ height: '12px', width: '30%', borderRadius: '4px' }}></div>
                      </div>
                      <div className="skeleton-price" style={{ height: '16px', width: '50px', borderRadius: '4px' }}></div>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', gap: '10px', marginBottom: '25px' }}>
                    <div className="skeleton-line" style={{ flex: 1, height: '40px', borderRadius: '4px' }}></div>
                    <div className="skeleton-button" style={{ width: '80px', height: '40px', borderRadius: '4px' }}></div>
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', borderTop: '1px solid #f2f2f2', paddingTop: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div className="skeleton-line" style={{ height: '14px', width: '80px', borderRadius: '4px' }}></div>
                      <div className="skeleton-price" style={{ height: '14px', width: '50px', borderRadius: '4px' }}></div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div className="skeleton-line" style={{ height: '14px', width: '80px', borderRadius: '4px' }}></div>
                      <div className="skeleton-price" style={{ height: '14px', width: '50px', borderRadius: '4px' }}></div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #f2f2f2', paddingTop: '15px', marginTop: '5px' }}>
                      <div className="skeleton-line" style={{ height: '18px', width: '60px', borderRadius: '4px' }}></div>
                      <div className="skeleton-price" style={{ height: '18px', width: '80px', borderRadius: '4px' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'logout':
        return (
          <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '60vh', width: '100%' }}>
            <style>{`
              @keyframes logout-spin {
                to { transform: rotate(360deg); }
              }
            `}</style>
            <span style={{
              display: 'inline-block',
              width: '40px',
              height: '40px',
              border: '3px solid #5578f4',
              borderRightColor: 'transparent',
              borderRadius: '50%',
              animation: 'logout-spin 0.75s linear infinite',
              marginBottom: '15px'
            }}></span>
            <h3 className="text-muted" style={{ fontWeight: '400' }}>Logging out...</h3>
          </div>
        );
      
      case 'product-detail':
        return (
          <div className="page-content skeleton-product-detail" style={{ padding: '20px 0' }}>
            <div className="holder" style={{ borderBottom: '1px solid #f2f2f2', paddingBottom: '15px', marginBottom: '25px' }}>
              <div className="container">
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <div className="skeleton-line" style={{ height: '14px', width: '50px' }}></div>
                  <span style={{ color: '#ccc', fontSize: '12px' }}>&gt;</span>
                  <div className="skeleton-line" style={{ height: '14px', width: '70px' }}></div>
                  <span style={{ color: '#ccc', fontSize: '12px' }}>&gt;</span>
                  <div className="skeleton-line" style={{ height: '14px', width: '180px' }}></div>
                </div>
              </div>
            </div>
            
            <div className="holder">
              <div className="container">
                <div className="row">
                  <div className="col-md-8 col-lg-8 col-xl-8">
                    <div className="skeleton-image" style={{ width: '100%', height: '480px', borderRadius: '8px', minHeight: '400px' }}></div>
                  </div>
                  
                  <div className="col-md-10 col-lg-10 col-xl-10 mt-2 mt-md-0" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div>
                      <div className="skeleton-title" style={{ height: '36px', width: '95%', marginBottom: '12px', borderRadius: '4px' }}></div>
                      <div className="skeleton-title" style={{ height: '36px', width: '60%', marginBottom: '25px', borderRadius: '4px' }}></div>
                      
                      <div className="skeleton-price" style={{ height: '36px', width: '25%', marginBottom: '20px', borderRadius: '4px' }}></div>
                    </div>
                    
                    <div>
                      <div className="skeleton-line" style={{ height: '18px', width: '120px', marginBottom: '12px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ height: '14px', width: '100%', marginBottom: '8px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ height: '14px', width: '90%', marginBottom: '8px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ height: '14px', width: '75%', marginBottom: '20px', borderRadius: '4px' }}></div>
                    </div>
                    
                    <div>
                      <div className="skeleton-line" style={{ height: '14px', width: '80px', marginBottom: '8px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ height: '8px', width: '100%', borderRadius: '4px', marginBottom: '20px' }}></div>
                    </div>
                    
                    <div style={{ border: '1px solid #f2f2f2', borderRadius: '6px', padding: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                        <div className="skeleton-line" style={{ height: '14px', width: '160px', borderRadius: '4px' }}></div>
                        <div className="skeleton-line" style={{ height: '14px', width: '140px', borderRadius: '4px' }}></div>
                      </div>
                      <div className="skeleton-line" style={{ height: '14px', width: '120px', borderRadius: '4px' }}></div>
                    </div>
                    
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '10px', flexWrap: 'wrap' }}>
                      <div className="skeleton-line" style={{ width: '120px', height: '44px', borderRadius: '4px' }}></div>
                      <div className="skeleton-button" style={{ flex: 1, minWidth: '150px', height: '44px', borderRadius: '4px' }}></div>
                      <div className="skeleton-line" style={{ width: '44px', height: '44px', borderRadius: '50%' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="holder" style={{ marginTop: '60px' }}>
              <div className="container">
                <div style={{ display: 'flex', gap: '30px', borderBottom: '2px solid #f2f2f2', paddingBottom: '12px', marginBottom: '25px', overflowX: 'auto' }}>
                  <div className="skeleton-line" style={{ height: '18px', width: '100px', flexShrink: 0 }}></div>
                  <div className="skeleton-line" style={{ height: '18px', width: '100px', flexShrink: 0 }}></div>
                  <div className="skeleton-line" style={{ height: '18px', width: '100px', flexShrink: 0 }}></div>
                  <div className="skeleton-line" style={{ height: '18px', width: '100px', flexShrink: 0 }}></div>
                  <div className="skeleton-line" style={{ height: '18px', width: '150px', flexShrink: 0 }}></div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <div className="skeleton-line" style={{ height: '20px', width: '200px' }}></div>
                    <div className="skeleton-line" style={{ height: '20px', flex: 1, minWidth: '150px' }}></div>
                  </div>
                  <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <div className="skeleton-line" style={{ height: '20px', width: '200px' }}></div>
                    <div className="skeleton-line" style={{ height: '20px', flex: 1, minWidth: '150px' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      
      case 'category-card':
        return (
          <div className="skeleton-category-card">
            <div className="skeleton-image"></div>
            <div className="skeleton-title"></div>
          </div>
        );
      
      case 'hero-banner':
        return (
          <div className="skeleton-hero-banner">
            <div className="skeleton-image"></div>
          </div>
        );
      
      case 'partner-logo':
        return (
          <div className="skeleton-partner-logo">
            <div className="skeleton-image"></div>
          </div>
        );
      
      case 'feature-card':
        return (
          <div className="skeleton-feature-card">
            <div className="skeleton-icon"></div>
            <div className="skeleton-content">
              <div className="skeleton-title"></div>
              <div className="skeleton-description"></div>
            </div>
          </div>
        );
      
      case 'account-details':
        return (
          <div style={{ border: 'none', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.07)', background: '#ffffff', overflow: 'hidden', marginBottom: '25px', width: '100%' }}>
            {/* Profile Header Skeleton */}
            <div style={{ background: 'linear-gradient(135deg, #f0f2f5 0%, #e4e7eb 100%)', padding: '32px 28px 28px', position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <div className="skeleton-image" style={{ width: '80px', height: '80px', borderRadius: '50%', flexShrink: 0, background: '#e1e4e8' }}></div>
                <div style={{ flex: 1 }}>
                  <div className="skeleton-line" style={{ height: '24px', width: '220px', marginBottom: '8px', borderRadius: '4px' }}></div>
                  <div className="skeleton-line" style={{ height: '14px', width: '160px', borderRadius: '4px' }}></div>
                </div>
                <div className="skeleton-button" style={{ width: '120px', height: '40px', borderRadius: '30px', flexShrink: 0 }}></div>
              </div>
            </div>

            {/* Info Grid Skeletons */}
            <div style={{ padding: '24px 28px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div style={{ background: '#f8f9ff', border: '1px solid #eef0fb', borderRadius: '12px', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div className="skeleton-image" style={{ width: '38px', height: '38px', borderRadius: '10px', flexShrink: 0 }}></div>
                <div style={{ flex: 1 }}>
                  <div className="skeleton-line" style={{ height: '11px', width: '70px', marginBottom: '6px', borderRadius: '2px' }}></div>
                  <div className="skeleton-line" style={{ height: '16px', width: '110px', borderRadius: '4px' }}></div>
                </div>
              </div>
              <div style={{ background: '#f8f9ff', border: '1px solid #eef0fb', borderRadius: '12px', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div className="skeleton-image" style={{ width: '38px', height: '38px', borderRadius: '10px', flexShrink: 0 }}></div>
                <div style={{ flex: 1 }}>
                  <div className="skeleton-line" style={{ height: '11px', width: '70px', marginBottom: '6px', borderRadius: '2px' }}></div>
                  <div className="skeleton-line" style={{ height: '16px', width: '110px', borderRadius: '4px' }}></div>
                </div>
              </div>
              <div style={{ background: '#f8f9ff', border: '1px solid #eef0fb', borderRadius: '12px', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div className="skeleton-image" style={{ width: '38px', height: '38px', borderRadius: '10px', flexShrink: 0 }}></div>
                <div style={{ flex: 1 }}>
                  <div className="skeleton-line" style={{ height: '11px', width: '90px', marginBottom: '6px', borderRadius: '2px' }}></div>
                  <div className="skeleton-line" style={{ height: '16px', width: '160px', borderRadius: '4px' }}></div>
                </div>
              </div>
              <div style={{ background: '#f8f9ff', border: '1px solid #eef0fb', borderRadius: '12px', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div className="skeleton-image" style={{ width: '38px', height: '38px', borderRadius: '10px', flexShrink: 0 }}></div>
                <div style={{ flex: 1 }}>
                  <div className="skeleton-line" style={{ height: '11px', width: '80px', marginBottom: '6px', borderRadius: '2px' }}></div>
                  <div className="skeleton-line" style={{ height: '16px', width: '120px', borderRadius: '4px' }}></div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'invoice':
        return (
          <div style={{ minHeight: '80vh', padding: '0 0 50px' }}>
            <div className="container">
              {/* Print Header banner */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                <div className="skeleton-line" style={{ height: '32px', width: '160px', borderRadius: '6px' }}></div>
              </div>
              <div className="skeleton-line" style={{ height: '38px', width: '130px', borderRadius: '6px' }}></div>
            </div>

            {/* Main invoice card */}
            <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '28px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
              {/* Ship To, Billing, Metadata Columns */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '30px' }}>
                {/* Ship To */}
                <div>
                  <div className="skeleton-line" style={{ height: '20px', width: '90px', marginBottom: '14px', borderRadius: '4px' }}></div>
                  <div className="skeleton-line" style={{ height: '16px', width: '140px', marginBottom: '8px', borderRadius: '3px' }}></div>
                  <div className="skeleton-line" style={{ height: '14px', width: '100%', marginBottom: '6px', borderRadius: '3px' }}></div>
                  <div className="skeleton-line" style={{ height: '14px', width: '80%', borderRadius: '3px' }}></div>
                </div>
                {/* Billing */}
                <div>
                  <div className="skeleton-line" style={{ height: '20px', width: '120px', marginBottom: '14px', borderRadius: '4px' }}></div>
                  <div className="skeleton-line" style={{ height: '16px', width: '140px', marginBottom: '8px', borderRadius: '3px' }}></div>
                  <div className="skeleton-line" style={{ height: '14px', width: '95%', marginBottom: '6px', borderRadius: '3px' }}></div>
                  <div className="skeleton-line" style={{ height: '14px', width: '75%', borderRadius: '3px' }}></div>
                </div>
                {/* Metadata */}
                <div>
                  <div className="skeleton-line" style={{ height: '16px', width: '180px', marginBottom: '10px', borderRadius: '3px' }}></div>
                  <div className="skeleton-line" style={{ height: '14px', width: '90px', marginBottom: '10px', borderRadius: '3px' }}></div>
                  <div className="skeleton-line" style={{ height: '14px', width: '150px', marginBottom: '10px', borderRadius: '3px' }}></div>
                  <div className="skeleton-line" style={{ height: '14px', width: '130px', borderRadius: '3px' }}></div>
                </div>
              </div>

              <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '0' }} />

              {/* Items list section */}
              <div>
                <div className="skeleton-line" style={{ height: '22px', width: '130px', marginBottom: '16px', borderRadius: '4px' }}></div>
                <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                  {/* Table headers */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 3fr 1fr', background: '#f8fafc', padding: '12px 20px', borderBottom: '1px solid #e2e8f0' }}>
                    {['60px', '120px', '70px'].map((w, i) => (
                      <div key={i} className="skeleton-line" style={{ height: '14px', width: w, borderRadius: '3px' }}></div>
                    ))}
                  </div>
                  {/* Table rows */}
                  {[1, 2, 3].map(i => (
                    <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.2fr 3fr 1fr', padding: '16px 20px', borderBottom: i < 3 ? '1px solid #f1f5f9' : 'none', alignItems: 'center' }}>
                      <div className="skeleton-line" style={{ height: '14px', width: '40px', borderRadius: '3px' }}></div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        <div className="skeleton-line" style={{ height: '15px', width: '85%', borderRadius: '3px' }}></div>
                        <div className="skeleton-line" style={{ height: '12px', width: '35%', borderRadius: '2px' }}></div>
                      </div>
                      <div className="skeleton-line" style={{ height: '14px', width: '60px', borderRadius: '3px' }}></div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Totals block */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <div style={{ width: '300px', display: 'flex', flexDirection: 'column', gap: '12px', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', background: '#fafbfc' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="skeleton-line" style={{ height: '13px', width: '70px', borderRadius: '3px' }}></div>
                    <div className="skeleton-line" style={{ height: '13px', width: '65px', borderRadius: '3px' }}></div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="skeleton-line" style={{ height: '13px', width: '85px', borderRadius: '3px' }}></div>
                    <div className="skeleton-line" style={{ height: '13px', width: '50px', borderRadius: '3px' }}></div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '12px', borderTop: '1px solid #e2e8f0' }}>
                    <div className="skeleton-line" style={{ height: '16px', width: '60px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '16px', width: '80px', borderRadius: '4px' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );

      case 'cart':
        return (
          <div style={{ minHeight: '80vh', padding: '0 0 50px' }}>
            <div className="container">
              {/* Breadcrumbs */}
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '30px' }}>
                <div className="skeleton-line" style={{ height: '14px', width: '50px' }}></div>
                <div style={{ color: '#ccc', fontSize: '12px' }}>/</div>
                <div className="skeleton-line" style={{ height: '14px', width: '60px' }}></div>
              </div>

              {/* Shopping Cart Title */}
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <div className="skeleton-line" style={{ height: '32px', width: '220px', margin: '0 auto', borderRadius: '6px' }}></div>
              </div>

              {/* Main Cart Area */}
              <div className="row">
                {/* Left Column: Cart items table */}
                <div className="col-lg-11 col-xl-13">
                  <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                    {/* Table Header */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 3fr 1.2fr 1.2fr 1fr', background: '#f8fafc', padding: '12px 20px', borderBottom: '1px solid #e2e8f0' }}>
                      {['60px', '80px', '40px', '50px', '10px'].map((w, i) => (
                        <div key={i} className="skeleton-line" style={{ height: '14px', width: w, borderRadius: '3px' }}></div>
                      ))}
                    </div>
                    {/* Cart Rows */}
                    {[1, 2].map(i => (
                      <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.2fr 3fr 1.2fr 1.2fr 1fr', padding: '16px 20px', borderBottom: i < 2 ? '1px solid #f1f5f9' : 'none', alignItems: 'center' }}>
                        <div className="skeleton-image" style={{ width: '80px', height: '80px', borderRadius: '6px' }}></div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                          <div className="skeleton-line" style={{ height: '15px', width: '80%', borderRadius: '3px' }}></div>
                          <div className="skeleton-line" style={{ height: '12px', width: '30%', borderRadius: '2px' }}></div>
                        </div>
                        <div className="skeleton-line" style={{ height: '34px', width: '70px', borderRadius: '6px' }}></div>
                        <div className="skeleton-line" style={{ height: '16px', width: '50px', borderRadius: '3px' }}></div>
                        <div className="skeleton-line" style={{ height: '24px', width: '24px', borderRadius: '50%' }}></div>
                      </div>
                    ))}
                  </div>

                  {/* Clear All button */}
                  <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <div className="skeleton-button" style={{ height: '38px', width: '120px', borderRadius: '6px', margin: '0 auto' }}></div>
                  </div>
                </div>

                {/* Right Column: Checkout Card */}
                <div className="col-lg-7 col-xl-5 mt-3 mt-md-0">
                  <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '24px', background: '#f8fafc', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div className="skeleton-line" style={{ height: '18px', width: '50px', borderRadius: '3px' }}></div>
                      <div className="skeleton-line" style={{ height: '18px', width: '70px', borderRadius: '3px' }}></div>
                    </div>
                    <div className="skeleton-button" style={{ height: '44px', width: '100%', borderRadius: '6px' }}></div>
                    <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '8px 0' }} />
                    <div>
                      <div className="skeleton-line" style={{ height: '14px', width: '120px', marginBottom: '8px', borderRadius: '3px' }}></div>
                      <div className="skeleton-line" style={{ height: '12px', width: '100%', marginBottom: '6px', borderRadius: '2px' }}></div>
                      <div className="skeleton-line" style={{ height: '12px', width: '80%', borderRadius: '2px' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'wishlist':
        return (
          <div style={{ minHeight: '80vh', padding: '0 0 50px' }}>
            <div className="container">
              {/* Breadcrumbs */}
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '30px' }}>
                <div className="skeleton-line" style={{ height: '14px', width: '50px' }}></div>
                <div style={{ color: '#ccc', fontSize: '12px' }}>/</div>
                <div className="skeleton-line" style={{ height: '14px', width: '60px' }}></div>
              </div>

              {/* Title */}
              <div className="skeleton-line" style={{ height: '28px', width: '160px', marginBottom: '24px', borderRadius: '4px' }}></div>

              {/* Grid */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '20px' }}>
                {[1, 2, 3].map(i => (
                  <div key={i} style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <div className="skeleton-image" style={{ width: '100%', height: '220px', borderRadius: '0' }}></div>
                    <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <div className="skeleton-line" style={{ height: '12px', width: '40%', borderRadius: '2px' }}></div>
                      <div className="skeleton-line" style={{ height: '16px', width: '80%', borderRadius: '3px' }}></div>
                      <div className="skeleton-line" style={{ height: '14px', width: '30%', borderRadius: '3px', marginTop: '4px' }}></div>
                      <div className="skeleton-button" style={{ height: '36px', width: '100%', borderRadius: '6px', marginTop: '12px' }}></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'account-history':
        return (
          <div style={{ minHeight: '70vh', padding: '0 0 40px' }}>
            <div className="container">
              {/* Page heading */}
              <div className="skeleton-line" style={{ height: '30px', width: '200px', marginBottom: '20px', borderRadius: '6px' }}></div>
              {/* Controls row */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px', gap: '12px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div className="skeleton-line" style={{ height: '16px', width: '40px', borderRadius: '4px' }}></div>
                  <div className="skeleton-line" style={{ height: '36px', width: '70px', borderRadius: '6px' }}></div>
                  <div className="skeleton-line" style={{ height: '16px', width: '55px', borderRadius: '4px' }}></div>
                </div>
                <div className="skeleton-line" style={{ height: '36px', width: '220px', borderRadius: '8px' }}></div>
              </div>
              {/* Table */}
              <div style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                {/* Table header */}
                <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1.2fr 1fr 1fr 1fr', gap: '0', background: '#f4f6fb', padding: '14px 20px', borderBottom: '1px solid #eef0f7' }}>
                  {['130px','110px','90px','80px','90px'].map((w,i) => (
                    <div key={i} className="skeleton-line" style={{ height: '16px', width: w, borderRadius: '4px' }}></div>
                  ))}
                </div>
                {/* Table rows */}
                {[1,2,3,4,5].map(i => (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.2fr 1.2fr 1fr 1fr 1fr', gap: '0', padding: '16px 20px', borderBottom: '1px solid #f5f5f8', alignItems: 'center', background: i % 2 === 0 ? '#fafbfd' : '#fff' }}>
                    <div className="skeleton-line" style={{ height: '15px', width: '110px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '14px', width: '90px', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '26px', width: '80px', borderRadius: '50px' }}></div>
                    <div className="skeleton-line" style={{ height: '16px', width: '70px', borderRadius: '4px' }}></div>
                    <div className="skeleton-button" style={{ height: '32px', width: '100px', borderRadius: '8px' }}></div>
                  </div>
                ))}
              </div>
              {/* Pagination */}
              <div style={{ display: 'flex', gap: '8px', marginTop: '20px', justifyContent: 'flex-start' }}>
                {[1,2,3,4].map(i => (
                  <div key={i} className="skeleton-line" style={{ height: '32px', width: '32px', borderRadius: '6px' }}></div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'policy-page':
        return (
          <div style={{ background: '#f7f8fc', minHeight: '70vh' }}>
            {/* Breadcrumb skeleton */}
            <div style={{ background: '#eef1fb', padding: '12px 0' }}>
              <div className="container">
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <div className="skeleton-line" style={{ height: '13px', width: '40px', borderRadius: '3px' }}></div>
                  <div style={{ color: '#ccc', fontSize: '12px' }}>/</div>
                  <div className="skeleton-line" style={{ height: '13px', width: '100px', borderRadius: '3px' }}></div>
                </div>
              </div>
            </div>

            {/* Hero skeleton */}
            <div style={{ background: 'linear-gradient(135deg, #d8e0fb 0%, #e4ebfd 100%)', padding: '56px 0 52px' }}>
              <div className="container" style={{ textAlign: 'center' }}>
                <div className="skeleton-image" style={{ width: '64px', height: '64px', borderRadius: '18px', margin: '0 auto 18px', display: 'block' }}></div>
                <div className="skeleton-line" style={{ height: '32px', width: '240px', margin: '0 auto 12px', borderRadius: '6px' }}></div>
                <div className="skeleton-line" style={{ height: '16px', width: '300px', margin: '0 auto', borderRadius: '4px' }}></div>
              </div>
            </div>

            {/* Card skeleton */}
            <div style={{ padding: '48px 0 64px' }}>
              <div className="container">
                <div style={{ background: '#fff', borderRadius: '20px', boxShadow: '0 4px 32px rgba(0,0,0,0.07)', padding: '48px 52px', maxWidth: '820px', margin: '0 auto' }}>
                  {/* Section 1 */}
                  <div style={{ marginBottom: '36px', paddingBottom: '36px', borderBottom: '1px solid #f2f3f8' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                      <div className="skeleton-image" style={{ width: '32px', height: '32px', borderRadius: '8px', flexShrink: 0 }}></div>
                      <div className="skeleton-line" style={{ height: '20px', width: '180px', borderRadius: '4px' }}></div>
                    </div>
                    <div className="skeleton-line" style={{ height: '15px', width: '100%', marginBottom: '10px', borderRadius: '3px' }}></div>
                    <div className="skeleton-line" style={{ height: '15px', width: '85%', marginBottom: '10px', borderRadius: '3px' }}></div>
                    <div className="skeleton-line" style={{ height: '15px', width: '92%', borderRadius: '3px' }}></div>
                  </div>
                  {/* Section 2 */}
                  <div style={{ marginBottom: '36px', paddingBottom: '36px', borderBottom: '1px solid #f2f3f8' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                      <div className="skeleton-image" style={{ width: '32px', height: '32px', borderRadius: '8px', flexShrink: 0 }}></div>
                      <div className="skeleton-line" style={{ height: '20px', width: '220px', borderRadius: '4px' }}></div>
                    </div>
                    {/* Info box */}
                    <div style={{ background: '#f0f4ff', borderLeft: '4px solid #c5d2fb', borderRadius: '10px', padding: '16px 20px', marginBottom: '16px' }}>
                      <div className="skeleton-line" style={{ height: '14px', width: '90%', borderRadius: '3px' }}></div>
                    </div>
                    {[100, 75, 88, 60].map((w, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '7px 0', borderBottom: i < 3 ? '1px solid #f5f5f5' : 'none' }}>
                        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#d0d8fb', flexShrink: 0 }}></div>
                        <div className="skeleton-line" style={{ height: '14px', width: `${w}%`, borderRadius: '3px' }}></div>
                      </div>
                    ))}
                  </div>
                  {/* Section 3 */}
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                      <div className="skeleton-image" style={{ width: '32px', height: '32px', borderRadius: '8px', flexShrink: 0 }}></div>
                      <div className="skeleton-line" style={{ height: '20px', width: '140px', borderRadius: '4px' }}></div>
                    </div>
                    <div className="skeleton-line" style={{ height: '15px', width: '100%', marginBottom: '10px', borderRadius: '3px' }}></div>
                    <div className="skeleton-line" style={{ height: '15px', width: '70%', borderRadius: '3px' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'sign-in':
        return (
          <div style={{ minHeight: '60vh', padding: '50px 0' }}>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-18 col-lg-12">
                  <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <div className="skeleton-line" style={{ height: '32px', width: '120px', margin: '0 auto', borderRadius: '6px' }}></div>
                  </div>
                  <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '30px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div className="skeleton-line" style={{ height: '45px', width: '100%', borderRadius: '4px' }}></div>
                    <div className="skeleton-line" style={{ height: '45px', width: '100%', borderRadius: '4px' }}></div>
                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                      <div className="skeleton-button" style={{ height: '44px', width: '110px', margin: '0 auto', borderRadius: '4px' }}></div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                    <div className="skeleton-line" style={{ height: '16px', width: '130px', borderRadius: '3px' }}></div>
                    <div className="skeleton-line" style={{ height: '16px', width: '150px', borderRadius: '3px' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'sign-up':
        return (
          <div style={{ minHeight: '70vh', padding: '50px 0' }}>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-18 col-lg-12">
                  <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <div className="skeleton-line" style={{ height: '32px', width: '220px', margin: '0 auto', borderRadius: '6px' }}></div>
                  </div>
                  <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '30px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                      {[1, 2, 3, 4].map(i => (
                        <div key={i}>
                          <div className="skeleton-line" style={{ height: '14px', width: '80px', marginBottom: '8px', borderRadius: '3px' }}></div>
                          <div className="skeleton-line" style={{ height: '45px', width: '100%', borderRadius: '4px' }}></div>
                        </div>
                      ))}
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                      <div className="skeleton-button" style={{ height: '44px', width: '140px', margin: '0 auto', borderRadius: '4px' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'forgot-password':
        return (
          <div style={{ minHeight: '60vh', padding: '50px 0' }}>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-18 col-lg-12">
                  <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <div className="skeleton-line" style={{ height: '32px', width: '260px', margin: '0 auto', borderRadius: '6px' }}></div>
                  </div>
                  <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '30px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div className="skeleton-line" style={{ height: '45px', width: '100%', borderRadius: '4px' }}></div>
                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                      <div className="skeleton-button" style={{ height: '44px', width: '150px', margin: '0 auto', borderRadius: '4px' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className="skeleton-default">
            <div className="skeleton-line" style={{ width: '75%', height: '20px' }}></div>
            <div className="skeleton-line" style={{ width: '100%' }}></div>
            <div className="skeleton-line" style={{ width: '90%' }}></div>
            <div className="skeleton-line" style={{ width: '100%' }}></div>
            <div className="skeleton-line short" style={{ width: '55%' }}></div>
            <div className="skeleton-line" style={{ width: '100%', marginTop: '8px' }}></div>
            <div className="skeleton-line" style={{ width: '88%' }}></div>
            <div className="skeleton-line" style={{ width: '70%' }}></div>
          </div>
        );
    }
  };

  const pageLevelSkeletons = [
    'checkout',
    'product-detail',
    'product-listing',
    'invoice',
    'cart',
    'wishlist',
    'account-history',
    'policy-page',
    'sign-in',
    'sign-up',
    'forgot-password',
    'account-details',
    'logout'
  ];

  if (isProductCard || pageLevelSkeletons.includes(type)) {
    return renderSkeleton(type);
  }

  return (
    <div className="skeleton-loader-container">
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="skeleton-item">
          {renderSkeleton(type)}
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
